import { render, staticRenderFns } from "./BGG.vue?vue&type=template&id=000b6640&scoped=true"
import script from "./BGG.vue?vue&type=script&lang=js"
export * from "./BGG.vue?vue&type=script&lang=js"
import style0 from "./BGG.vue?vue&type=style&index=0&id=000b6640&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000b6640",
  null
  
)

export default component.exports